import { ImageBackground as FastImage } from 'react-native'

export default FastImage
